import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    tableHeader: {
      color: theme.palette.primary.main,
    },
    table: {
      textAlign: 'left',
      marginTop: '10px',
      width: '1300px',
      '& th': {
        fontSize: '15px',
      },
    },
    inputField: {
      width: '140px',
    },
    hiddenFileInput: {
      display: 'none',
    },
    deleteButton: {
      color: '#FF3300',
    },
    blueIcon: {
      color: '#336699',
    },
    saveButton: {
      color: '#090',
      fontWeight: 'bold',
    },
    btnMarginRight: {
      marginRight: '10px',
    },
    confirmMessage: {
      color: '#090',
      fontWeight: 'bold',
    },
    primaryColor: {
      color: theme.palette.primary.main,
    },
    dialogTitle: {
      color: theme.palette.primary.main,
      padding: '12px',
    },
    divider: {
      margin: theme.spacing(2.5, 0),
    },
    bottomClear: {
      marginBottom: '20px',
    },
    required: {
      width: '6px',
      height: '6px',
      background: '#d9534f',
      display: 'inline-block',
      margin: '4px 4px 0 4px',
      borderRadius: '3px',
    },
  };
};
